<template>
  <div class="header">
    <div class="inner">
      <el-row>
        <el-col class="item" :lg="2" :md="2" :xs="8">
          <img src="@/assets/image/logo.png" alt="" style="width: 100%"  @click="goto('/index')"/>
        </el-col>
        <el-col class="item" :lg="2" :md="2" :xs="8" :offset="16" >
          <span @click="goto('/index')">首页</span>
        </el-col>
        <el-col class="item" :lg="2" :md="2" :xs="5" @click="goList">
          <span @click="goto('/recruitList')">校园招聘</span>
        </el-col>
        <i class="el-icon-menu"  @click="showMenu"></i>
      </el-row>
    </div>
    <el-drawer
      title=""
      :visible.sync="drawer"
      :direction="direction"
      :before-close="handleClose">
      <el-row>
        <span @click="goto('/index')">首页</span>
      </el-row>
      <el-row>
        <span @click="goto('/recruitList')">校园招聘</span>
      </el-row>
    </el-drawer>
  </div>

</template>

<script>
export default {
  name: "Headers",
  data() {
    return {
      drawer: false,
      direction: 'rtl',
    };
  },
  methods:{
    showMenu(){
      this.drawer = !this.drawer;
    },
    handleClose(){
      this.drawer = false;
    },
    goto(address){
      this.$router.push(address);
    },
    goIndex() {
      this.$router.push("/index");
    },
    goList() {
      this.$router.push("/recruitList");
    },
  }
};
</script>

<style lang="scss" scoped>
.header {
  background-color: #1890ff;
  height: 60px;
  line-height: 60px;
  padding: 0 120px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10000;
  @media (max-width: 1200px) {
    padding: 0 0 0 10px;
  }
  .inner {
    height: 100%;
    .el-icon-menu{
      display: none;
      font-size: 30px;
      color: #fff;
      position: absolute;
      top: 50%;
      right: 15px;
      transform: translateY(-50%);
      @media (max-width: 1200px) {
        display: block;
      }
    }
    .el-row {
      height: 100%;
    }
    .item {
      &:first-of-type {
        @media (max-width: 1200px) {
          margin-right: 0;
        }
      }
      @media (max-width: 1200px) {
        &:nth-child(2), &:nth-child(3){
          display: none;
        }
      }
      display: flex;
      height: 100%;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 14px;
      cursor: pointer;
      @media (max-width: 1200px) {
        font-size: 14px;
      }
    }
  }
}
</style>
<style lang="scss">
.el-drawer__wrapper{
  .el-drawer{
    background-color: #000;
    .el-drawer__header{
      padding: 20px 15px 0 20px;
    }
    .el-dialog__close{
      color: #fff;
    }
    .el-drawer__body{
      line-height: 2;
      span{
        display: inline-block;
        width: 100%;
        text-align: right;
        padding-right: 15px;
        color: #fff;
        font-weight: bold;
        margin-bottom: 10px;
      }
    }
  }
  
}
</style>


// WEBPACK FOOTER //
// src/components/Headers.vue